import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "calendar-grid-header" }
const _hoisted_3 = { class: "calendar-grid-body" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "day-number" }
const _hoisted_6 = { class: "d-flex justify-center pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      tile: "",
      class: "overflow-hidden no-scroll-bar pb-3",
      elevation: "0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar, {
          class: "app_bar",
          fixed: "",
          color: "primary",
          dark: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "w-100 px-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "8",
                  class: "pr-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selectedYear,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
                        _ctx.onYearOrMonthChange
                      ],
                      items: _ctx.yearList,
                      "item-title": "label",
                      "item-value": "value",
                      dense: "",
                      "hide-details": "",
                      class: "year-select"
                    }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "pl-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selectedMonth,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedMonth) = $event)),
                        _ctx.onYearOrMonthChange
                      ],
                      items: _ctx.monthList,
                      dense: "",
                      "hide-details": "",
                      class: "month-select",
                      "item-title": "label",
                      "item-value": "value"
                    }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_expand_transition, null, {
          default: _withCtx(() => [
            (_ctx.isCalendar)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  class: "mt-16 pa-2",
                  elevation: "1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdayLabels, (w) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: w.label,
                          class: _normalizeClass(['weekday-label', w.isSunday ? 'text-red' : w.isSaturday ? 'text-blue' : ''])
                        }, _toDisplayString(w.label), 3))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.startOffset, (n) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'empty-' + n,
                          class: "day-cell empty"
                        }))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysInMonth, (day) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: day,
                          class: _normalizeClass(["day-cell", { 'is-selected': _ctx.isSelected(day) }]),
                          onClick: ($event: any) => (_ctx.handleDateClick(day))
                        }, [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(day), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.isUnRead(_ctx.formatDate(day)) ? 'unRead-dot' : 'read-dot')
                          }, null, 2)
                        ], 10, _hoisted_4))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex justify-center pb-4" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_btn, {
            text: "",
            color: "grey darken-1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('common.cancel')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}